import { StoreChat } from '../../Types/StoreTypes';
export const SET_CHAT = 'SET_CHAT';
export const SET_IS_SENDIING = 'SET_IS_SENDIING';
export const SET_IS_NEW_CHAT = 'SET_IS_NEW_CHAT';
export const SET_CHAT_LOADED = 'SET_CHAT_LOADED';
export const SET_MESSAGES_LOADED = 'SET_MESSAGES_LOADED';
export const SET_PROMPTS = 'SET_PROMPTS';
export const SET_WEBSOCKET_ERROR = 'SET_WEBSOCKET_ERROR';
export const SET_IS_STOPABLE = 'SET_IS_STOPABLE';
export const SET_CHAT_DLP_ACTIVE = 'SET_CHAT_DLP_ACTIVE';
export const SET_UPDATE_CHAT = 'SET_UPDATE_CHAT';
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES';
export const SET_CHAT_CONTAINER_STYLES = 'SET_CHAT_CONTAINER_STYLES';
export const SET_CHAT_DLP = 'SET_CHAT_DLP';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const ADD_MESSAGE = 'ADD_MESSAGE';

export function setChat(chats: Partial<StoreChat['chat']>) {
    return { type: SET_CHAT, payload: chats };
}

export function setIsSending(isSending: StoreChat['isSending']) {
    return { type: SET_IS_SENDIING, payload: isSending };
}

export function setIsNewChat(isNewChat: StoreChat['isNewChat']) {
    return { type: SET_IS_NEW_CHAT, payload: isNewChat };
}

export function setChatLoaded(chatLoaded: StoreChat['chatLoaded']) {
    return { type: SET_CHAT_LOADED, payload: chatLoaded };
}

export function setMessagesLoaded(messagesLoaded: StoreChat['messagesLoaded']) {
    return { type: SET_MESSAGES_LOADED, payload: messagesLoaded };
}

export function setPrompts(prompts: StoreChat['prompts']) {
    return { type: SET_PROMPTS, payload: prompts };
}

export function setWebsocketError(websocketError: StoreChat['websocketError']) {
    return { type: SET_WEBSOCKET_ERROR, payload: websocketError };
}

export function setIsStopable(isStopable: StoreChat['isStopable']) {
    return { type: SET_IS_STOPABLE, payload: isStopable };
}

export function setChatDlp(chatDlp: StoreChat['chat']['dlp']) {
    return { type: SET_CHAT_DLP, payload: chatDlp };
}

export function setChatDlpActive(chatDlpActive: StoreChat['chat']['dlp_active']) {
    return { type: SET_CHAT_DLP_ACTIVE, payload: chatDlpActive };
}

export function setUpdateChat(updateChat: StoreChat['updateChat']) {
    return { type: SET_UPDATE_CHAT, payload: updateChat };
}

export function setChatMessages(chatMessages: any) {
    return { type: SET_CHAT_MESSAGES, payload: chatMessages };
}

export function updateMessage(message: any) {
    return { type: UPDATE_MESSAGE, payload: message };
}

export function addMessage(message: any) {
    return { type: ADD_MESSAGE, payload: message };
}

export function setChatContainerStyles(chatContainerStyles: any) {
    return { type: SET_CHAT_CONTAINER_STYLES, payload: chatContainerStyles };
}
